<!-- ================================ BEGIN: Header Section ================================== -->

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white">
    <!--    <img src="companyInfo.loaderIcon" width="250px">-->
    </p>
</ngx-spinner>

<header style="margin-bottom: 10px;">
    <div  *ngIf="showNavbar">
        <navbar></navbar>
    </div>
</header>


<section id="content">
    <div >
        <router-outlet></router-outlet>
    </div>
</section>
<!-- ==================================== END: Content Section ==============================  -->
<!-- ==================================== BEGIN: Footer Section ==============================  -->
<footer >
    <ft-footer></ft-footer>
</footer>
<!-- ==================================== END: Footer Section ==============================  -->
